<template>
    <div>
        <div
            class="h3 ic-wrapper d-flex justify-content-end mb-0 mt-4"
            v-if="IS_MOBILE && GET_IS_MOBILE_GRAPHIC_SHOWN"
            @click="SET_HIDE_MOBILE_GRAPHIC"
        >
            <SvgIcon name="x-circle" :width="22" :height="22"/>
        </div>
        <b-row
            class="pt-1 mx-auto"
            :class="[{'d-none': IS_MOBILE && !GET_IS_MOBILE_GRAPHIC_SHOWN}]"
        >
            <b-col class="d-md-flex justify-content-center">
                <div class="dam-img" v-html="result" ref="svg"></div>
                <ProfileDamMxGraph v-if="result" :key="viewerRefresh"></ProfileDamMxGraph>
            </b-col>
        </b-row>
    </div>
</template>

<script>
    // vuex
    import {mapGetters, mapActions} from "vuex";
    import {SET_TAB_REDIRECT} from "../../store/actions/sensors";
    import {AUTH_LOGOUT} from "../../store/actions/auth";
    import {
        GET_IS_MOBILE_GRAPHIC_SHOWN,
        IS_MOBILE,
        SET_HIDE_MOBILE_GRAPHIC,
        SET_SHOW_MOBILE_GRAPHIC,
    } from "../../store/actions/profile";
    // utils
    import apiCall from '../../utils/api';
    import {removeMxTooltips} from "../../utils/common";
    // constants
    import {sensorsTableMap} from "../../constants/sensors-constants";
    // components
    import ProfileDamMxGraph from "./ProfileDamMxGraph";
    import SvgIcon from '../shared/SvgIcon';

    export default {
        name: 'ProfileDamBody',
        components: {
            ProfileDamMxGraph,
            SvgIcon
        },
        data () {
            return {
                drawer: null,
                result: null,
                error: false,
                viewerRefresh: 0,
            }
        },
        async created() {
            // get data in advance
            // we need to have it, then load the script to parse it
            await this.getDamProfileImgData();
        },
        mounted() {
            // add event listener so if url hash is changed, get the hash
            window.addEventListener('hashchange', this.handleSensorClick, false);

            // force refresh the viewer wrapper component
            // as to re-add the script and re-run it
            this.viewerRefresh++;
        },
        computed: {
            ...mapGetters(['getDamData', 'currentDamSelectedId', GET_IS_MOBILE_GRAPHIC_SHOWN, IS_MOBILE ]),
        },
        methods: {
            ...mapActions([
                AUTH_LOGOUT,
                SET_HIDE_MOBILE_GRAPHIC,
                SET_SHOW_MOBILE_GRAPHIC,
                SET_TAB_REDIRECT
            ]),
            /**
             * Get encoded html data from BE. Will need the viewer script to parse it.
             * @returns {Promise<void>}
             */
            async getDamProfileImgData() {
                try {
                    const {data} = await apiCall.getDamProfileImg(this.currentDamSelectedId);
                    this.result = data.PS_station;
                } catch (error) {
                    this.error = true;
                    if (error.request.status === 401) {
                        // if resp is unauthorized, logout
                        this.AUTH_LOGOUT();
                    }
                }
            },
            handleSensorClick() {
                // get the link (node) name after clicked (ex. #Piezometer1)
                const hash = location.hash;
                // set default
                let tabName = 'controller';
                let linkConfig = {name: 'sensors', params: {}};

                for (let tab in sensorsTableMap) {
                    if (hash !== '#' && hash.toLowerCase().includes(tab)) {
                        tabName = tab;
                        break;
                    }
                }

                if (this.currentDamSelectedId || this.$route.params.id) {
                    linkConfig['params']['id'] = this.currentDamSelectedId || this.$route.params.id;
                }
                linkConfig['query'] = {tab: tabName};

                this.SET_TAB_REDIRECT(true);
                this.$router.push(linkConfig);
            }
        },
        beforeDestroy() {
            this.viewerRefresh = 0;
            this.result = null;

            // remove listener as we no longer need it
            window.removeEventListener('hashchange', this.handleSensorClick, false);
            removeMxTooltips();

            // close (reset) the profile image graphic on mobile
            this.SET_HIDE_MOBILE_GRAPHIC();
        }
    }
</script>

<style lang="scss">
    @import "src/assets/scss/_variables";

    .dam-img {
        position: $dam-profile-container-position;
        display: block;

        &::before {
            content: '';
            z-index: $dam-profile-img-mask-el-z-index;
            position: $dam-profile-img-mask-el-position;
            width: 100%;
            height: $dam-profile-img-mask-height;
            background-color: $dam-profile-img-mask-bg;
        }

        &>div {
            width: 100% !important;
            border: 1px solid $dam-profile-img-border !important;
        }

        @include media-breakpoint-down(md) {
            overflow: auto;
        }

        @media (min-width: 1250px ) {
            &>div  {
                transform: scale($dam-profile-img-scale-1);
                transform-origin: top left;
            }
        }

        @media (min-width: 1600px) {
            &>div  {
                transform: scale($dam-profile-img-scale-2);
                transform-origin: top left;
            }
        }
    }

    svg {
        a:hover {
            path {
                fill: green;
            }
        }
    }
</style>